/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import reactivityImg from 'assets/images/reactivity.jpg'
import data_flowImg from 'assets/images/data-flow.jpg'
import state_hoistingImg from 'assets/images/state-hoisting.gif'
import deep_state_hoistingImg from 'assets/images/deep-state-hoisting.gif'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Дополнительные материалы</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://medium.com/fullstack-academy/thunks-in-redux-the-basics-85e538a3fe60"
          target="_blank"
        >
          Thunks in Redux: The Basics
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/xihoZZU0gao" target="_blank">
          Redux Thunk Tricks
        </a>
      </li>
    </ul>
  </section>
))
